import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={props?.width || 21}
    height={props?.height || 20}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx={10.3335}
      cy={10}
      r={9}
      fill="white"
      stroke="#BD2120"
      strokeWidth={2}
    />
    <line
      x1={3.76604}
      y1={2.85779}
      x2={15.9145}
      y2={17.3578}
      stroke="#BD2120"
      strokeWidth={2}
    />
  </svg>
);
export default SVGComponent;
